module.exports = __webpack_public_path__ + "static/media/pakistan.c108e389.jpg";